import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
//import chevLeft from 'icons/chevron-left-24.png';
import AppVersion from '../common/AppVersion';
import { getCurrentUser, getTestState, getAppState, setStateInstalled, getOnline } from 'store/storeValtio';
import HelpTitle from 'components/common/HelpTitle';
import { APIVersion, OBLatestVersion } from 'drugData/lookupDrugs';

export default function Development() {
    //console.log('Development');
    //const [scope, setScope] = useState('No scope');
    const navigate = useNavigate();
    const currentUser = getCurrentUser();

    function appIsInstalled() {
      // For iOS
      if(window.navigator.standalone) return true
    
      // For Android
      if(window.matchMedia('(display-mode: standalone)').matches) return true
    
      // If neither is true, it's not installed
      return false
    }

    var standalone = appIsInstalled();
    setStateInstalled(standalone);

    const w = Math.floor(window.screen.width);
    const aw = Math.floor(window.screen.availWidth);
    const h = Math.floor(window.screen.height);
    const ah = Math.floor(window.screen.availHeight);
    const vw = Math.floor(window.visualViewport.width);
    const vh = Math.floor(window.visualViewport.height);
    //const raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    //console.log('Chrome: ', raw);

    async function getCacheUrls() {
      if ('serviceWorker' in navigator) {
        const cacheUrls = [];
        await caches.keys()
        .then(async (cacheNames) => {
          //console.log('Cache names:', cacheNames, cacheNames[0]);
          const cacheName = cacheNames[0];
          await caches.open(cacheName)
          .then(async (cache) => {
            await cache.keys()
            .then((keys) => {
              //console.log("cache keys: ", keys);
              for (const key of keys) {
                cacheUrls.push(key.url);
              }
              console.log(cacheUrls);
              return cacheUrls;
            }
          )}
        )})
        .catch((err) => {
          console.log('getCacheNames error: ', err);
        });
      } else {
        console.log('No Service Worker found');
      }
      return null;
    }

    const testState = getTestState();
    const appState = getAppState();
    const cn0 = 'pl-8 text-left';
    const cn1 = 'w-24 pr-8 text-right';
    
    return (
      <div className='pt-8 h-full text-center font-semibold text-xl bg-blue-200 '>
        <HelpTitle title="Development" helpSubject="Development" />
        <div className='flex justify-center mt-20'>
          <table className='table-fixed w-10/12 px-4'>
            <thead></thead>
            <tbody>
              <tr className='zebra'>
                <td className={cn0}>Width:</td>
                <td className={cn1}>{w}</td>
              </tr>
              <tr className='zebra'>
                <td className={cn0}>Available Width:</td>
                <td className={cn1}>{aw}</td>
              </tr>
              <tr className='zebra'>
                <td className={cn0}>Height:</td>
                <td className={cn1}>{h}</td>
              </tr>
              <tr className='zebra'>
                <td className={cn0}>Available Height:</td>
                <td className={cn1}>{ah}</td>
              </tr>
              <tr className='zebra'>
                <td className={cn0}>Viewport Width:</td>
                <td className={cn1}>{vw}</td>
              </tr>
              <tr className='zebra'>
                <td className={cn0}>Viewport Height:</td>
                <td className={cn1}>{vh}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className='flex flex-col items-center justify-center mt-20 text-xl font-semibold'>
          <div>
            App is {appState.installed ? 'installed' : 'not installed'}
          </div>
          <div>
            Standalone: {standalone ? 'true' : 'false'}
          </div>
          <div>
            <AppVersion />
          </div>
          <div>
            User Id: {currentUser.userId}
          </div>
          {/* <div>
            Registration Id: {currentUser.registrationId}
          </div> */}
          <div>
            Test Mode: {testState.testMode ? 'On' : 'Off'}
          </div>
          <div>
            Demo Mode: {testState.demoMode ? 'On' : 'Off'}
          </div>
          <div>
            {appState.scope ? appState.scope : 'No Scope'}
          </div>
          <div>
            OBLatestVersion: {OBLatestVersion}
          </div>
          <div>
            APIVersion: {getOnline() ? APIVersion : "Offline"}
          </div>
        </div>
      </div>
    );
  }

